/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "../../utils/bindUrl";
import {
  IForm,
  IResponseListForms,
  IResponseShowForm,
} from "../../interfaces/forms";

const BASE = "/forms";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listForms({
  filter,
  includes,
  page,
  limit,
  sort,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListForms>(BASE, {
    params: { filter, includes, page, limit, sort, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showForm({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowForm>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createForm({ form }: { form: IForm }) {
  const { data } = await api.post<IResponseShowForm>(BASE, { form });
  return data;
}

export async function updateForm({
  id,
  form,
}: {
  id: string | number;
  form: IForm;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowForm>(url, { form });
  return data;
}

export async function deleteForm({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.delete<any>(url);
  return data;
}
